import React from "react";
import { Exclamation } from "assets/svg";
import plugin from "utils/currentPlugin";
import {
  ContainerImage,
  Footer,
  IllustrationImage,
  Text,
  Title,
  Modal,
  Container,
  Content,
  ButtonRefresh
} from "./styles";

const ModalError = ({ open, buttonName, title, message, onButtonClick }) => {
  const getIconTop = () => {
    return (
      <ContainerImage>
        <IllustrationImage iv src={Exclamation} />
      </ContainerImage>
    );
  };

  const getTitle = () => {
    return title || <>Ops!</>;
  };

  const getMessage = () => {
    return message || "Um erro inesperado aconteceu.";
  };

  const getButtonText = () => {
    return buttonName || "Fechar";
  };

  const contentError = () => (
    <>
      {getIconTop()}
      <Title data-testid="error-title">{getTitle()}</Title>
      <Text data-testid="error-message">{getMessage()}</Text>
      <Footer>
        <ButtonRefresh
          data-testid="error-button-text"
          theme={plugin ? plugin.name : ""}
          onClick={onButtonClick}
        >
          {getButtonText()}
        </ButtonRefresh>
      </Footer>
    </>
  );

  if (!open) return null;

  return (
    <Modal isOpen={open} appElement={document.getElementById("react-view")}>
      <Container data-testid="modal-error-header-container">
        <Content>{contentError()}</Content>
      </Container>
    </Modal>
  );
};

export default ModalError;
